function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.355 17.765l-15.093 8.901A1.5 1.5 0 018 25.374V7.184a1.5 1.5 0 012.286-1.277l15.094 9.288a1.5 1.5 0 01-.024 2.57z",
    fill: props.color || 'black',
    stroke: props.color || 'black'
  }));
}
export default SvgPlay;